<template>
  <section>
    <PublicNavigation />
    <div class="container">
      <div class="row">
        <div class="col-md-8 mx-auto">
          <div class="privacy">
            <h1 style="color:#000">Integrity Policy and User Conditions</h1>
            <p class="revision">
              Last revision: 2023-10-13
            </p>
            <ul class="list-unstyled">
              <li>
                <h2>1. General</h2>
                <p>
                  Comstream AB, a Swedish entity with organizational number 556945-8911, hereinafter
                  “Comstream” is working according to the policy below and is responsible for
                  personal data in relation to the use of provided online services hereinafter
                  referred to as “Jobshark”. Comstream will respect and protect your personal data
                  and personal integrity according to the regulations in GDPR and other valid
                  legislations.
                </p>
                <p>
                  To be able to use Jobshark, you must carefully read the text and accept the
                  conditions below.
                </p>
              </li>
              <li>
                <h2>2. Gathering of Information</h2>
                <p>
                  To be able to provide the service, we gather and process information about you.
                  Using some of the services, like registration and uploading of CV, will mean that
                  information about your personal identity (name, address, phone number, e-mail,
                  competence areas, education, experience, civil status, interests, etc) will be
                  gathered and stored.
                </p>
              </li>
              <li>
                <h2>3. Cookies</h2>
                <p>
                  Jobshark is using cookies to improve the user experience. To be able to
                  continuously develop our services and products and to be able to customize our
                  information to you, we may also gather information about what web browser you are
                  using, your IP address and similar information.
                </p>
              </li>
              <li>
                <h2>4. Use of Information</h2>
                <p>
                  Jobshark is a platform where you can apply to different job opportunities. An
                  application means that the stored information you choose to enclose can be
                  distributed to the corresponding employer after review by us.
                </p>
                <p>
                  You accept that we may contact you personally when there are job opportunities
                  that can be suitable for you. You decide in each specific case whether you are
                  interested and if your application should be submitted to the corresponding
                  employer. Comstream has no control nor responsibility how CVs and other sent
                  information will be handled by the receiving employer.
                </p>
                <p>
                  If we are required by law or by decision by a government, the information about
                  you can be handed over to corresponding authority.
                </p>
                <p>
                  Your information can be used in an aggregated, non-identifying way for statistical
                  purposes. We may also contact you via email, SMS or other means with general
                  information related to our services or other activities, competitions or similar
                  that we arrange.
                </p>
              </li>
              <li>
                <h2>5. Retention Period</h2>
                <p>
                  Personal data is stored in Jobshark as long as it is necessary to fulfill the
                  purposes for which they were collected. Information from registrations, CVs and
                  job applications are retained until you request the data to be deleted.
                </p>
              </li>
              <li>
                <h2>6. Your Rights</h2>
                <p>
                  If you do not wish that your personal data shall be gathered, used and transferred
                  according to this policy, you can withdraw your approval of the integrity policy
                  at any time by contacting us. If you withdraw your approval, your account and
                  profile information will be deleted. You also have the right to request access to
                  or to request correction of the personal information about you. Please contact us
                  in such situations.
                </p>
              </li>
              <li>
                <h2>7. Security</h2>
                <p>
                  You are responsible that your user name and password will not be disclosed to
                  unauthorized persons.
                </p>
                <p>
                  Comstream is responsible to enforce adequate security measures to protect your
                  stored information. However, Internet is an open environment and we cannot
                  guarantee that unauthorized will not compromise our security measures.
                </p>
              </li>
              <li>
                <h2>8. Misuse of User Account</h2>
                <p>
                  In the case of fraud or other misuse of Jobshark, Comstream reserves the right to
                  deny you access to the service.
                </p>
                <p>
                  You hereby also undertake not to use Jobshark for any unlawful purpose or to
                  publish materials that are offensive, vulgar, obscene, threatening, degrading,
                  racist or discriminatory. It is not permitted to deliberately publish information
                  about yourself that is not genuine or to use the service on behalf of third
                  parties. It is not permitted to market products or services through Jobshark.
                </p>
              </li>
              <li>
                <h2>9. Changes to the Privacy Policy</h2>
                <p>
                  If there are significant changes to this policy, Comstream will notify you via
                  email or through a message on the site.
                </p>
              </li>
              <li>
                <h2>10. Applicable Laws</h2>
                <p>
                  This Contract shall be governed by the laws of Sweden and any dispute shall be
                  settled by a general Swedish court of law.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import PublicNavigation from '../../components/Navigations/PublicNavigation';
import Footer from '@/components/Navigations/PublicFooter';
import titleMixin from '../../mixins/titleMixin';
export default {
  mixins: [titleMixin],
  title() {
    return 'Integrity Policy and User Conditions | Jobshark';
  },
  canonicalLink() {
    return 'https://jobshark.eu/integrity';
  },
  components: {
    PublicNavigation,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';
.container {
  max-width: 1320px;
}
.privacy {
  padding: 100px 0;
  h1 {
    font-weight: 700;
    font-size: 24px;
  }
  .revision {
    font-style: italic;
    font-weight: 600;
    font-size: 14px;
  }
  .list-unstyled {
    li {
      margin-bottom: 12px;
      h2 {
        font-size: 16px;
        font-weight: 900;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
